/**
 * svgtoreact
 *
 * @author Michael Hsu
 */

import React from 'react';

export default function SVGMobile(props) {
  return (
    <svg width={26} height={42} viewBox="0 0 26 42" {...props}>
      <g fill="none">
        <path d="M-17-9h60v60h-60z" />
        <g fill="#fff">
          <path
            opacity=".5"
            d="M7 19h7v12h-7zm0-10h12v9h-12zm8 10h4v8h-4zm0 9h4v3h-4z"
          />
          <path d="M2 39.991c0 .008 21.999.009 21.999.009-.001 0 .001-37.991.001-37.991 0-.008-21.999-.009-21.999-.009.001 0-.001 37.991-.001 37.991zm-2-37.982c0-1.108.893-2.009 2.001-2.009h21.999c1.107 0 2.001.899 2.001 2.009v37.982c0 1.108-.893 2.009-2.001 2.009h-21.999c-1.107 0-2.001-.899-2.001-2.009v-37.982zm9 2.491h8c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-8c-.276 0-.5.224-.5.5s.224.5.5.5zm-3.5 3.503v23.993c0 .277.225.503.501.503h13.998c.278 0 .501-.224.501-.503v-23.993c0-.277-.225-.503-.501-.503h-13.998c-.278 0-.501.224-.501.503zm-1 0c0-.831.669-1.503 1.501-1.503h13.998c.829 0 1.501.675 1.501 1.503v23.993c0 .831-.669 1.503-1.501 1.503h-13.998c-.829 0-1.501-.675-1.501-1.503v-23.993zm8.5 30.997c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z" />
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/SVG/SVGMobile.js